import AppSelect from "./AppSelect";

export default AppSelect;